<template>
  <v-layout column class="grid-mode">
    <span
      class="mb-3 grey--text subheading"
      v-if="searchDocumentString.length > 0"
    >
      {{ documents.length }} resultado{{ documents.length !== 1 ? 's' : '' }} com o termo "{{ searchDocumentString }}"
    </span>
    <v-layout column>
      <section v-if="documentList.length > 0">
        <span class="caption grey--text font-weight-bold">Documentos</span>
        <v-layout wrap>
          <div
            wrap
            v-for="doc in documentList"
            :key="doc.id"
            @click.stop="onClickfile(doc)"
          >
            <document-thumb
              class="pointer mt-4 mx-4"
              :doc="doc"
              :searchDocumentString="searchDocumentString"
            />
          </div>
        </v-layout>
      </section>
      <section v-if="otherFileList.length > 0">
        <span class="caption grey--text font-weight-bold">Outros</span>
        <v-layout wrap>
          <div
            v-for="doc in otherFileList"
            :key="doc.id"
            @click.stop="onClickfile(doc)"
          >
            <document-thumb
              class="pointer mt-4 mx-4"
              :doc="doc"
              :searchDocumentString="searchDocumentString"
            />
          </div>
        </v-layout>
      </section>
      <v-layout
        v-show="(documentList.length + otherFileList.length) === 0"
        column
        align-center
      >
        <v-icon color="grey" class="mb-2 text--darken-2" size="64">mdi-file-hidden</v-icon>
        <span class="title grey--text text--darken-3">Não há documentos no processo!</span>
      </v-layout>
      <document-dialog
        v-if="showDocumentDialog"
        :doc="selectedDocument"
        :showDocumentDialog="showDocumentDialog"
        @closeDocumentDialog="closeDocumentDialog"
      />
    </v-layout>
    <attached-folders-list :currentFolder="folder" class="mt-5"/>
  </v-layout>
</template>

<script>
import { last } from 'lodash';
import AttachedFoldersList from '@/components/folder/list/AttachedFoldersList';
import DocumentDialog from '@/components/document/show/DocumentDialog';
import DocumentThumb from './DocumentThumb';

export default {
  name: 'GridMode',
  props: {
    documents: {
      type: Object,
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
    folder: {
      type: Object,
    }
  },
  components: {
    AttachedFoldersList,
    DocumentDialog,
    DocumentThumb,
  },
  data() {
    return {
      showDocumentDialog: false,
      selectedDocument: {},
    };
  },
  methods: {
    closeDocumentDialog() {
      this.showDocumentDialog = false;
    },
    onClickfile(doc) {
      if (doc.mime_type === 'audio/mpeg' ||
        doc.mime_type === 'application/mp3' ||
        doc.mime_type === 'image/png' ||
        doc.mime_type === 'image/jpg' ||
        doc.mime_type === 'image/jpeg' ||
        doc.mime_type === 'application/pdf'
      ) {
        this.showDocument(doc);
      } else {
        this.downloadFile(last(doc.document_versions).file);
      }
    },
    showDocument(doc) {
      this.selectedDocument = { ...doc };
      this.showDocumentDialog = true;
    },
    downloadFile(url) {
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', this.selectedDocument.docflow_number);
      a.click();
    },
  },
  computed: {
    documentList() {
      return this.documents.filter(item => item.mime_type === 'application/pdf');
    },
    otherFileList() {
      return this.documents.filter(item => item.mime_type !== 'application/pdf');
    },
  },
};
</script>

<style>
  .pointer {
    cursor: pointer;
  }
  .grid-mode {
    overflow-y: auto;
    max-height: calc(100vh - 64px);
  }
</style>



// WEBPACK FOOTER //
// src/components/document/grid/GridMode.vue